module.exports = __webpack_public_path__ + "static/scale-model-of-me-mural-in-nashville-tennessee-165222dc71012bee0f0daefafb87d06b.png";